<template>
	<div class="machines">
		<b-modal
			no-close-on-backdrop
			title=""
			class="modal-success"
			v-model="interestDlg"
			ok-variant="success"
			:ok-only="true"
			ok-title="Close"
			size="lg"
		>
			<b-container fluid>
				<b-row>
					<b-col>
						Thank you for showing interest in our promo.<br>We'll contact you very soon to discuss all the details"
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
		<b-modal
			no-close-on-backdrop
			title=""
			class="modal-success"
			v-model="showSediChiuse"
			ok-variant="success"
			:ok-only="true"
			ok-title="Close"
			size="lg"
		>
			<b-container fluid>
				<b-row>
					<b-col class="center">
						Please note that today<br>
                        <b v-for="s in sedichiuse" v-bind:key=s>{{s}}<br></b><br>
                        will be closed<br><br>
                        The local team will replay to your ticket or requests once they'll be back tomorrow.<br><br>
                        Thank you for your understanding
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
		<b-row class="h100 normargin">
			<b-col cols="4" class="schede h100">
				<template v-if="schede===false">
					<SemipolarSpinner :animation-duration="2000" :size="65" :color="'#ff1d5e'" />
				</template>
				<template v-else>
					<div v-if="schede.length > 5" class="mtop10 filtro">
						Filter:
						<input v-debounce:500="filtroSchedeChanged" type="text" />
					</div>
                    <div v-else style="height: 30px; margin: 10px;">&nbsp;</div>
					<div class="elenco">
						<div v-for="m of cschede" :key="m.codice + sfiltro">
							<SchedaMacchina :m="m" :info="true" :key="m.upd" />
						</div>
					</div>
				</template>
			</b-col>
			<b-col cols="5" class="h100 stats">
                <b-card class="carousel">
                    <div class="title">ANALYTICS</div>
                    <b-carousel
                        id="carousel-1"
                        v-model="slide"
                        :interval="cinterval"
                        controls
                        indicators
                    >
                        <b-carousel-slide
                            img-blank
                            caption="By Assistance Category"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceHoursPieChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                    field="type"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="Totals on site/remote intervents"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceTicketAssBarChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                    field="k"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="% on site/remote assistance"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceTicketAssPieChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="Totals on site/remote hours"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceTicketAssBarChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                    field="ore"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="Total assistance hours"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceHoursPieChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                    field="machine"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="Total assistance hours"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceTypeBarChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                />
                            </b-card>
                        </b-carousel-slide>
                        <b-carousel-slide
                            img-blank
                            caption="Total assistance hours"
                        >
                            <b-card class="chart" :key="codici">
                                <TotalAssistanceHoursPieChart
                                    :width="200"
                                    :height="60"
                                    :mcode="codici"
                                    field="pay"
                                />
                            </b-card>
                        </b-carousel-slide>
                    </b-carousel>
                </b-card>
				<b-card class="ticket">
					<div class="title">{{ticketsTitle}}</div>
					<br />
					<b-table
						hover
						sort-icon-left
						:items="tickets"
						:fields="fields"
					></b-table>
					<a v-if="!allTickets" href="#" @click.prevent="viewMore()">View more...</a>
				</b-card>
			</b-col>
			<b-col cols="3" class="h100 pr30">
				<ContactUs class="contatti" />
				<b-carousel
					id="carousel-2"
					v-model="slidep"
					:interval="pinterval"
					controls
					indicators
					background="white"
                    v-if="promos && promos.length>0"
				>
					<b-carousel-slide
						img-blank
						:caption="p.title"
						v-for="p of promos"
						:key="p.id"
					>
						<b-card
							class="promo"
							img-top
							:img-src="`/images/promo/${p.promoimage}`"
						>
							<b-card-text>
								{{ p.description }}
							</b-card-text>
							<b-button
                                class="tellmemore"
								href="#"
								variant="primary"
								@click="promoInterest(p)"
								>Tell me more</b-button
							>
							<b-button
                                v-if="!!p.link"
                                class="openlink"
								href="#"
								variant="primary"
								@click="openLink(p.link)"
								>Open</b-button
							>
						</b-card>
					</b-carousel-slide>
				</b-carousel>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import TotalAssistanceHoursPieChart from "@/components/TotalAssistanceHoursPieChart.vue";
import TotalAssistanceTicketAssBarChart from "@/components/TotalAssistanceTicketAssBarChart.vue";
import TotalAssistanceTicketAssPieChart from "@/components/TotalAssistanceTicketAssPieChart.vue";
import TotalAssistanceTypeBarChart from "@/components/TotalAssistanceTypeBarChart.vue";
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import ContactUs from "@/components/ContactUs.vue";
import { SemipolarSpinner } from "epic-spinners";
import { API } from "@/api.js";

export default {
	name: "Machines",
	components: {
		TotalAssistanceHoursPieChart,
		TotalAssistanceTicketAssBarChart,
		TotalAssistanceTicketAssPieChart,
		TotalAssistanceTypeBarChart,
		SchedaMacchina,
		ContactUs,
		SemipolarSpinner,
	},
	data() {
		return {
			interestDlg: false,
			slide: 0,
			slidep: 0,
			cinterval: 40000,
			pinterval: 56900, // così non ho sincronie con l'altro carousel !
			sfiltro: "",
			schede: false,
			fields: [
				{ key: "code", label: "Machine", sortable: true, class: "font-weight-bold" },
				{ key: "type", label: "Status", sortable: true },
				{ key: "date", sortable: true, formatter: "dateFormatter" },
			],
			tickets: [],
			promos: [],
			allTickets: false,
			ticketsTitle: "YOUR LAST TICKETS",
            sedichiuse: [],
            showSediChiuse: false
		};
	},
	async mounted() {
        let dateChecked = localStorage.getItem("dateChecked")
        if(dateChecked!="true") {
            localStorage.setItem("dateChecked","true")
            let date = await API.closingTime();
            // verifico se una delle date è di oggi
            let today = new Date()
            let todayStr = today.toISOString().split("T")[0]
            console.log("today",todayStr,date)
            let sedichiuse = []
            for(let d of date) {
                if(d.data.split("T")[0]==todayStr)
                    switch(d.sede) {
                        case "HQ":
                            sedichiuse.push("Marsilli HQ")
                            break
                        case "DEU":
                            sedichiuse.push("Marsilli Deutschland")
                            break
                        case "USA":
                            sedichiuse.push("Marsilli North America")
                            break
                        case "MEX":
                            sedichiuse.push("Marsilli Mexico")
                            break
                        case "ZH":
                            sedichiuse.push("Marsilli China")
                            break
                        default:
                            sedichiuse.push(d.sede)
                    }
            }
            if(sedichiuse.length>0) {
                console.log("trovata")
                this.sedichiuse = sedichiuse
                this.showSediChiuse = true
            }
        }
		// let promo = await API.getPromoMachines(); meglio ricostruirle a partire dalle promo
		let unitNames = await API.getUnitNames();
        // console.log("PROMO",promo)
		// aggiorno le promo
		this.promos = await API.getPromos(this.$store.getters.client_code);
        // ... ecco, qui costruisco le promo
        let promo = {}
        for(let p of this.promos) {
            if(p.machines) {
                //for(let m of p.machines.split(",")) {
                for(let m of p.machines) {
                    if(!promo[m])
                        promo[m] = []
                    if(!promo[m].includes(p.title))
                        promo[m].push(p.title)
                }
            }
        }

		console.log("promos", this.promos);
        console.log("promo", promo);
		let tickets = await API.lastTickets(8);
        if(tickets.length<8)
            this.allTickets = true
		this.tickets = tickets.map((t) => ({
			code: t.code,
			type: t.type,
			date: new Date(t.opendate),
		}));
		let data = await API.getUnits();
		let schede = data.map((d) => ({
			client: d.client_code,
			nome: d.name,
			codice: d.code,
			location: d.location,
			img: d.img,
			macchina: d.macchina,
			descr: d.descr,
			delivered: d.delivered,
			label_info: d.label_info,
			upd: 0,
			nomepers: (unitNames.find(u => u.code==d.code) || {}).name || d.name,
			locationpers: (unitNames.find(u => u.code==d.code) || {}).location || d.location,
            promo: promo[d.code]
		})); // upd serve per l'aggiornamento delle immagini
		// aggiungo le immagini
		this.schede = schede;

		this.$nextTick(async () => {
			let k = 1;
			for (let s of schede) {
				// buf.toString('base64')
				//s.image = 'data:image/png;base64,' + (await API.unitImage(s.codice))
				s.image = "/images/units/" + s.img;
				s.upd = k++;
			}
		});
	},
	computed: {
		codici() {
			return this.cschede.map((s) => s.codice).join("|");
		},
		cschede() {
			if (this.sfiltro == "") return this.schede || [];
			else
				return (this.schede || []).filter(
					(s) =>
						s.codice.includes(this.sfiltro) ||
						s.nome.includes(this.sfiltro) ||
						s.location.includes(this.sfiltro) ||
						s.nomepers.includes(this.sfiltro) ||
						s.locationpers.includes(this.sfiltro)
				);
		},
		logged() {
			// console.log("logged", this.$store.getters.logged);
			return this.$store.getters.logged ? "si" : "no";
		},
	},
	methods: {
		async viewMore(){
			this.allTickets = true
			let tickets = await API.lastTickets(999);
			this.tickets = tickets.map((t) => ({
				code: t.code,
				type: t.type,
				date: new Date(t.opendate),
			}));
			this.ticketsTitle = "YOUR TICKETS"
		},
		promoInterest(p) {
			console.log("promoInterest", p);
            this.interestDlg = true;
            let html = `E' stato mostrato interesse per la promo <b>${p.title}</b> da parte di<br>
            ${this.$store.getters.client_code}<br>
            ${this.$store.getters.name}<br>
            ${this.$store.getters.surname}<br>
            ${this.$store.getters.email}
            `;
			API.sendmail("promo_mail", "Interesse verso una promozione", "..vedi la versione in html..", html)
		},
		openLink(url) {
			console.log("openlink", url);
            window.open(url, '_blank').focus();
		},
		filtroSchedeChanged(val) {
			console.log("chg", val);
			this.sfiltro = val;
		},
		dateFormatter(value) {
			return value.toLocaleDateString();
		},
	},
};
</script>

<style scoped>
div.center {
    text-align: center;
}
div.normargin {
    margin-right: 0px;
}
div.h100 {
    height: 87vh; /* calc(100vh - 140px); */
}
div.h100.stats {
    overflow: hidden;
}
div.pr30 {
    padding-right: 30px;
}
div.mtop10 {
	margin-top: 10px;
	margin-bottom: 10px;
    height: 3vh;
}
div.machines {
	background-color: lightgrey;
	overflow: auto;
	height: 87vh; /* calc(100vh - 120px); */
	max-height: 87vh; /* calc(100vh - 120px); */
}
div.machines div.elenco {
	height: 80vh; /* calc(100vh - 190px); */
	overflow-y: auto;
}
div.card.carousel {
    margin-top: 5vh; /* 50px; */
    margin-bottom: 1vh; /* 10px; */
}
div.contatti {
    margin-top: 5vh; /* 50px; */
    margin-bottom: 1vh; /* 10px; */
}
div.contatti img {
    height: 14vh;
}
div.schede {
	height: calc(100vh - 140px);
	max-height: calc(100vh - 140px);
	/* overflow-y: auto; */
}
div.chart {
	max-height: 22vh; /* 250px; */
	min-height: 22vh; /* 250px; */
	height: 22vh; /* 250px; */
}
div.ticket {
	/* max-height: calc(100% - 330px);
  min-height: calc(100% - 330px);
  height: calc(100% - 330px); */
	max-height: 41vh; /* 400px; */
	min-height: 41vh; /* 400px; */
	height: 41vh; /* 400px; */
	overflow-y: auto;
}
div.ticket div.title {
	font-weight: 700;
    font-size: larger;
}
div.carousel div.title {
	font-weight: 700;
    font-size: larger;
}
div.promo div.card-body {
	/* display: none; */
	color: black;
}
div.promo {
    font-size: 2vh;
}
div.card.promo {
    border: inherit !important;
}
div.promo div {
    height: 24vh;
}
div.row.contatti img {
    width: 22vw;
}
</style>
<style>
div.machines div.ticket table td {
    padding: 1px;
}
div.machines .carousel-indicators li {
    background-color: black;
}
div.machines .carousel-control-next-icon {
    color: black !important;
    background-color: black;
}
div.machines .carousel-control-prev-icon {
    color: black !important;
    background-color: black;
}
div.machines .carousel-caption {
    color: black !important;
    position: absolute;
    top: -10px;
}
div.card.carousel {
    height: 38vh; /* 365px; */
}
#carousel-1 {
    height: 35vh; /* 300px; */
}
#carousel-1 img {
	height: 500px !important;
}
#carousel-2 {
	height: 65vh; /* calc(100vh - 340px); */
    overflow-y: auto;
}
#carousel-2 div.carousel-inner {
	height: 100%;
}
#carousel-2 div.carousel-item {
	height: 100%;
}
#carousel-2 p.card-text {
    max-height: 21vh;
    overflow-y: auto;
}
div.machines div.contatti > div.col {
	background-color: #6b1106;
	margin-left: 15px;
	margin-right: 15px;
}
div.machines div.elenco div.card {
	margin-bottom: 10px;
	margin-top: 0px !important;
}
div.machines a.tellmemore {
	background-color: #6b1106;
	border-color: #6b1106;
    position: fixed;
    bottom: 7vh;
    right: 10vw;
}
div.machines a.openlink {
	background-color: #6b1106;
	border-color: #6b1106;
    position: fixed;
    bottom: calc(7vh + 40px);
    right: calc(10vw + 25px);
}
</style>
